// A currencyCode like XOF or XAF is shared by several countries (each its own
// Currency row), so a bare code in a dropdown is ambiguous. Append the country
// only where the code is actually shared; unique codes stay plain.
export const buildCurrencyOptions = (currencies, allLabel = "All Currencies") => {
  const counts = currencies.reduce((acc, c) => {
    const code = c.currencyCode.toUpperCase();
    acc[code] = (acc[code] || 0) + 1;
    return acc;
  }, {});

  return [
    { label: allLabel, value: "" },
    ...currencies.map((c) => {
      const code = c.currencyCode.toUpperCase();
      return {
        value: `${code}|${(c.countryCode || "").toUpperCase()}`,
        label: counts[code] > 1 && c.country ? `${code} — ${c.country}` : code,
      };
    }),
  ];
};

// Splits a value produced by buildCurrencyOptions back into its parts.
export const parseCurrencyOption = (value) => {
  if (!value) return { currencyCode: undefined, countryCode: undefined };
  const [currencyCode, countryCode] = value.split("|");
  return { currencyCode, countryCode: countryCode || undefined };
};
